export const DIFFUSEURS = 'Diffuseurs';
export const THEMATIQUES = 'Thematiques';
export const MEDIAS = 'Medias';
export const RESEAUX = 'Reseaux';
export const FORMATSPAGE = 'FormatsPage';